import apiClient from "@/app/api/client";

export const integrationService = {
	list() {
		return apiClient.get("/integrations").then((r) => r.data);
	},
	get(id: number) {
		return apiClient.get(`/integrations/${id}`).then((r) => r.data);
	},
	create(data: Record<string, unknown>) {
		return apiClient.post("/integrations", data).then((r) => r.data);
	},
	update(id: number, data: Record<string, unknown>) {
		return apiClient.patch(`/integrations/${id}`, data).then((r) => r.data);
	},
	remove(id: number) {
		return apiClient.delete(`/integrations/${id}`).then((r) => r.data);
	},
};
